<!--
  ~ Copyright (c) Worldline 2023.
  -->

<ul class="links-list">
    <li *ngIf="rootScope.get().properties?.contact === 'page'"><a id="contact-page-link" (click)="goToContact()"
                                                                  href="">{{ 'footer.contact' | translate }}</a></li>
    <li *ngIf="rootScope.get().properties?.contact === 'external'"><a id="contact-external-link"
                                                                      href="{{ replaceArgsInUrl(this.rootScope.get().properties.contactLink) }}">{{ 'footer.contact' | translate }}</a>
    </li>
    <li *ngIf="rootScope.get().properties?.contact === 'mail'"><a id="contact-mail-link"
                                                                  href="mailto: {{ rootScope.get().properties.contactMailTo }}">{{ 'footer.contact' | translate }}</a>
    </li>

    <li *ngIf="rootScope.get().properties?.help === 'page'"><a id="help-page-link" (click)="goToHelp()"
                                                               href="">{{ 'footer.help' | translate }}</a></li>
    <li *ngIf="rootScope.get().properties?.help === 'external'"><a id="help-external-link"
                                                                   href="{{ replaceArgsInUrl(this.rootScope.get().properties.helpLink) }}">{{ 'footer.help' | translate }}</a>
    </li>

    <li *ngIf="rootScope.get().properties?.legalNotices === 'page'"><a id="legal-page-link" (click)="goToLegalNotices()"
                                                                       href="">{{ 'footer.legacy' | translate }}</a></li>
    <li *ngIf="rootScope.get().properties?.legalNotices === 'external'"><a id="legal-external-link"
                                                                           href="{{ replaceArgsInUrl(this.rootScope.get().properties.legalNoticesLink) }}">{{ 'footer.legacy' | translate }}</a>
    </li>
</ul>